// @flow
import React from "react"
import {translateGridToLayout, types, OFFSET_X, translateLayoutToGrid, updateWidths, updateLayout, updateLabel, removeComponent} from '../utils/grid'
import styled from 'styled-components'
import {observer} from 'mobx-react'
import abStore from '../stores/abTest'

import Input from './Input'
import Width from './Width'
import Number from './Number'
import GridArea from './GridArea'
import navStore from 'stores/navbar'
import storyStore from 'stores/storybook'

import RGL, { WidthProvider } from "react-grid-layout"
import type {FormattedGrid, GridName} from '../entities'
const ReactGridLayout = WidthProvider(RGL);



type Props = {|
  grid: FormattedGrid,
  onGridChange: (grid:FormattedGrid) => void,
  push: (path:string) => void,
  refresh: () => void,
  gridName: GridName
|}

type State = {
  layout: any,
  cols: number,
  activeComponent: null | {gridName:string, id: string|null}
}

export default observer(class DynamicMinMaxLayout extends React.Component<Props,State> {

  state = { 
    layout: translateGridToLayout(this.props.grid, this.props.grid.widths.length+OFFSET_X), 
    cols: this.props.grid.widths.length+OFFSET_X,
    activeComponent: null
  }

  componentWillUnmount(){
    navStore.clearButtonList()
  }

  updatePanel = () => {
    const {activeComponent} = this.state
    if(!activeComponent) return
    navStore.setButtonList([
      {
        label: 'Editieren',
        background: 'rgb(0, 150, 136)',
        onClick: () => {activeComponent.id && storyStore.setComponent(activeComponent.id)}
      },{
        label: 'Buffer',
        background: 'rgb(233, 30, 99)',
        onClick: () => this.removeComponent(activeComponent)
      }
    ])
  }

  setCols = (cols:*) => () => {
    const prevCols = this.state.cols
    if(prevCols > cols && this.state.layout.find(row => row.type !== 'WIDTH' && (row.w+row.x) > cols)){
      return
    }
    this.setState({ cols, layout: updateWidths(this.state.layout, cols) })
  }

  handleLayoutChange = (nativeLayout:*) => {
    const layout = updateLayout(this.state.layout, nativeLayout)
    this.setState({ layout })
    this.clearActiveComponent()
    const grid = translateLayoutToGrid(layout)
    this.props.onGridChange(grid)
  }

  setActiveComponent = (activeComponent:*) => {
    this.setState({activeComponent}, this.updatePanel)
  }

  clearActiveComponent = () => {
    this.setState({activeComponent: null}, navStore.clearButtonList)
  }

  removeComponent = (component:*) => {
    const layout = removeComponent(this.state.layout, component)
    this.setState({ layout })
    this.clearActiveComponent()
    const grid = translateLayoutToGrid(layout)
    this.props.onGridChange(grid)
    this.props.refresh()
  }

  updateLabel = (component:*, label:*) => {
    const layout = updateLabel(this.state.layout, component, label)
    this.setState({ layout })
    const grid = translateLayoutToGrid(layout)
    this.props.onGridChange(grid)
  }

  createComponent = (l:*,i:*) => {
    return (
      <GridAreaWrapper key={l.i} data-grid={l} isStatic={l.static}>
        { l.type === types.HEIGHT ? (
          <Width 
            width={l.name}
            abMode={abStore.getMode(this.props.gridName, l.y-1)}
            onChange={(width,abMode) => {
              this.updateLabel(l, width)
              abStore.setMode(this.props.gridName, l.y-1, abMode)
            }}
          />
        )
        : l.type === types.WIDTH ? <Input value={l.name} onChange={label => this.updateLabel(l, label)} />// $FlowFixMe
        : l.type === types.COLS ? <Number value={this.state.cols} onChange={this.setCols} />
        : l.type === types.COMPONENT ? (
          <GridArea 
            component={l.component} 
            wasRemoved={l.wasRemoved} 
            active={l.component === this.state.activeComponent}
            onClick={this.setActiveComponent}
          />
        )
        : <div>{l.name}</div>}
      </GridAreaWrapper>
    )
  }

  render() {
    const gridProps = {
      isDraggable: true,
      isResizable: true,
      items: 5,
      rowHeight: 30,
      onLayoutChange: this.handleLayoutChange,
      cols: this.state.cols,
      useCSSTransforms: false
    }
    
    return (
      <ReactGridLayout {...gridProps}>
        {this.state.layout.map(this.createComponent)}
      </ReactGridLayout>
    );
  }
})

const GridAreaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .el-static {
    background: none;
    border: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/GridLayout.js